import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <main className="flex min-h-[60vh] flex-col items-center justify-center px-6 text-center">
      <h1 className="font-serif text-6xl font-bold text-phoenix-blue-900">404</h1>
      <p className="mt-4 text-lg text-gray-600">We couldn&apos;t find the page you were looking for.</p>
      <Link
        to="/"
        className="mt-8 rounded-md bg-phoenix-blue-600 px-6 py-3 font-semibold text-white transition hover:bg-phoenix-blue-700"
      >
        Back to Home
      </Link>
    </main>
  );
}
